export const TableFields = ['id', 'client', 'versionId', 'title', 'created', 'numberOfQuestions'];
